// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1DLE1","left":"StickyBox_left__Fqn_L","right":"StickyBox_right__3Njk3"};